module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Medium_NO.3f1d20ff.png";